export default __webpack_public_path__ + "static/media/error.d4ef1b86.svg";